<template>
    <div>
        <div class="meter orange nostripes">
            <span class="progressbar_background"></span>
            <span :style="styleObject" ></span>
        </div>
        <!--<div class="container">
            <div class="progressbar" :style="styleObject"></div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: "Progressbar",
        props: {
            progress: {
                type: Number,
                required: true
            }
        },
        computed:{
            styleObject(){
                let color = this.progress <= 80 ? '#F1403A' : (this.progress <=94 ? '#F7E84E' : '#009AA6');
                let prog = this.progress;
                if(this.progress > 100){
                    prog = 100;
                }
                return {
                    width: prog+'%',
                    background: color,
                    transition: 'width 500ms'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
        height: 10px;
        position: relative;
        background: #F2F2F4;
        border-radius: 10px;
    }

    .progressbar {
        transition: width 500ms;
        position: absolute;
        border-radius: 10px;
        width: 0%;
        height: 100%;
        left: 0;
        top: 0;
        color: #fff;
        text-align: center;
        padding: 7px 0;
    }

    .progressbar_background{
        width: 100%;
        height:11px !important;
        position: absolute !important;
        background: #eceef0;
    }

    .meter {
        box-sizing: content-box;
        height: .7rem; /* Can be anything */
        position: relative;
        background: #fff;
        //border-radius: 25px;
        padding: .5rem 0;
        margin-top: 5px;
    }
    .meter > span {
        display: block;
        height: 100%;
        border-radius: 10px;
        position: relative;
        overflow: hidden;
    }
    .meter > span:after,
    .animate > span > span{
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1;
        background-size: 50px 50px;
        animation: move 2s linear infinite;
        border-radius: 10px;
        overflow: hidden;
    }

    .animate > span:after {
        display: none;
    }

    @keyframes move {
        0% {
            background-position: 0 0;
        }
        100% {
            background-position: 50px 50px;
        }
    }

</style>